import Vue from "vue";
import App from "./App.vue";
import store from './store'
//引入路由
import router from "./router";
import "@/assets/css/base.less";
//element ui按需引入
import { MessageBox } from "element-ui";
import {
  Button,
  Dialog,
  message,
	Tooltip,
} from "element-ui";
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Tooltip);
Vue.prototype.$message = message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.config.productionTip = false;
import moment from "moment";
Vue.prototype.bus = new Vue();

Vue.filter("datefmt", function (input, fmtstring) {
  //当input为时间戳，需转为Number类型
  if (input) {
    if (input.toString().length == 10) {
      return moment(Number(input) * 1000).format(fmtstring);
    } else {
      return moment(Number(input)).format(fmtstring);
    }
  } else {
    return "";
  }
});
new Vue({
  store,
  render: (h) => h(App),
  //注册路由
  router,
}).$mount("#app");
